import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
// import { DetailBorrowFormTestComponent } from "../../../../components/borrowSystem/BorrowForm/JuristicType/DetailBorrowFormTestComponent";
import { FormTestComponent } from "../../../components/borrowSystem/BorrowForm/FormTestComponent";
import { Footer } from "../../../components/share/Footer";

export function FormTestContainer() {
  const titleName = "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการทดสอบมาตรฐานฝีมือแรงงาน";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <FormTestComponent />
      <Footer />
    </div>
  );
}
